import { useCallback, useContext, useEffect, useState } from "react";

import {
  Spinner,
  SpinnerSize,
  Stack,
} from "@fluentui/react";
import { t } from "i18next";
import Moment from "moment";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import DialogBox from "../../../components/Modal/DialogBox";
import AssignmentConflictModal from "../../../components/Modal/AssignmentConflictModal";
import { CUSTOM_STYLES, HIDE_ASSIGN_DROPDOWN_TABS, TAB_NAME, TOAST_TYPE, USERTYPES } from "../../../constants/Constants";
import loaderContext from "../../../context/loader/LoaderContext";
import studylistContext from "../../../context/studylist/StudylistContext";
import studyReportContext from "../../../context/studyreport/StudyReportContext";
import themeContext from "../../../context/theme/ThemeContext";
import toastContext from "../../../context/toast/ToastContext";
import userContext from "../../../context/users/UserContext";
import {
  RevertCloseStudyApi,
  assignProvider,
  assignProviderByAdmin,
  getClientProviders,
  getTimeSpendByRadiologist,
  validateAssignment,
} from "../../../service/StudyListService";
import CustomDropDown from "../../../components/CustomDropDown/CustomDropDown";
import MoreIcon from "../../../components/SVGComponents/MoreIcon";
import EyeIcon from "../../../components/SVGComponents/EyeIcon";
import AssignmentDataPopUp from "./AssignmentDataPopUp/AssignmentDataPopUp";
import FirmRadiologist from "./RadiologistColumn/FirmRadiologist";
import SuperAdminRadiologist from "./RadiologistColumn/SuperAdminRadiologist";
import { SendReportEmail } from "./Actions/SendReportEmail";
import { getEnv } from '../../../helpers/EnvHelper';
import { getRadiologistDisplayName } from "../../../helpers/CommonUtility";

const dropDownStyle = {
  dropdown: {
    width: "180px",
    height: "32px",
    borderRadius: "12px",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: "600",
  },
  dropdownItem: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: "600",
  },
  dropdownItemSelected: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: "600",
  },
  dropdownItemsWrapper: {
    maxHeight: "300px",
  },
};

const smallSpinnerStyle = {
  circle: {
    height: "20px",
    width: "20px",
    borderWidth: "3px",
  },
  label: {
    color: "white",
  },
};

const badgeStyle = {
  backgroundColor: "#BBDEFF",
  height: "18px",
  fontSize: "9px",
  color: "#0035BE",
  display: "flex",
  alignItems: "center",
  width: "fit-content",
  fontFamily: "Open Sans",
  fontWeight: "700",
  padding: "0px 5px",
  borderRadius: "10px",
  lineHeight: "16px",
  gap: "10px",
};

const RadiologistDetails = (props) => {
  let enterprise =
    getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true" ||
      getEnv("REACT_APP_ENTERPRISE_PLATFORM") == true
      ? true
      : false;
  let baseURL = window.location.origin + "/";
  const { roles, authenticated, loadByUsername, showConfirmation, userId } =
    useContext(userContext);

  const {
    dataQueryState, setDataQueryState,
    studyListLoading, setStudyListLoading,
    studyListRef, showClientName,
    updateLockUnlockRows,
    menuForClosedAndReverted,
    setRefreshRequired,
    refreshRequired,
    setResetRowSelection,
    showSendReportModal,
    setShowSendReportModal
  } = useContext(studylistContext);

  const { themeName } = useContext(themeContext);

  const {
    alertSuccessModal,
    setAlertSuccessModal
  } = useContext(studyReportContext);
  const [assignedProviderId, setAssignedProviderId] = useState("");
  const [providerId, setProviderId] = useState(
    props.data.row.original.assignmentList[0].providerId
  );
  const [assignmentId, setAssignmentId] = useState();
  const [selected, setSelected] = useState(false);
  const [clientProvidersList, setClientProvidersList] = useState([]);
  const { ref, setLoaderRunning, setLoaderAnnotationRunning } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [reportingProviderDto, setReportingProviderDto] = useState({});
  const [notAssignedYet, setNotAssignedYet] = useState(false);
  const [assignUpdateDetails, setAssignUpdateDetails] = useState({});
  const [isLoadingAssignment, setIsLoadingAssignment] = useState(false);


  const [showPopUp, setShowPopUp] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showAssignmentConflictModal, setShowAssignmentConflictModal] = useState(false);
  const [assignmentConflicts, setAssignmentConflicts] = useState([]);
  const [showRevertReponseModal, setShowRevertReponseModal] = useState(false);
  const [showRevertConfirmModal, setShowRevertConfirmModal] = useState(false);
  const [showSendReportModalBool, setShowSendReportModalBool] = useState(false);


  let reviewerId = props.data.row.original.peerReviewAssignment?.reviewerId;
  let reviewStatus = props.data.row.original.peerReviewAssignment?.reviewStatus;

  const radiologistStackAssigned = {
    fontSize: "14px",
    fontWeight: "400",
    alignItems: "center",
    marginTop: "4px",
  };

  const confirmDialogBoxStyles = {
    root: {
      backgroundColor: 'rgb(22, 21, 20, 0.7)'
    },
    main: {
      boxSizing: "border-box",
      borderRadius: "10px 10px 10px 10px",
      fontFamily: "Open Sans",
      fontStyle: "normal",
      boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
      border: "1px solid #4B4B4B",
    },
  }

  const radiologistRoleStackAssigned = {
    fontSize: "14px",
    fontWeight: "400",
    alignItems: "center",
  };

  const radiologistNameStack = {
    fontSize: "14px",
    fontWeight: "400",
    alignItems: "center",
    marginTop: "8px",
    lineHeight: '20px'
  };

  const firstRowNameStack = {
    fontSize: "14px",
    fontWeight: "400",
    alignItems: "center",
    lineHeight: '20px'
  };

  const handleRadiologistTimeSpent = async () => {
    setLoaderRunning(true);
    //setLoaderAnnotationRunning(true);
    ref.current.continuousStart();
    const body = {
      studyId: props.data.row.original.id,
      isParent: null
    }
    const res = await getTimeSpendByRadiologist(body);
    if (res.data.result == "SUCCESS") {
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = t("string-literals.time-spent-radiologist");
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = res.data?.data?.timeSpent;
        return newItem;
      });
      setLoaderRunning(false);
      ref.current.complete();
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.failed-message"));

    }

  }

  useEffect(() => {
    if (props.data.length > 0)
      if (!authenticated) {
        loadByUsername();
      }
  }, []);

  useEffect(() => {
    let cnt = props.data.row.original.assignmentList.length;
    let obj = { 0: false, 1: false, 2: false, 3: false };
    if (cnt >= 1) {
      for (let i = 0; i < cnt; i++) {
        if (
          props.data.row.original.assignmentList[i].providerName != undefined
          && props.data.row.original.assignmentList[i].providerName != ""
        ) {
          obj[i] = true;
        }
      }
      setNotAssignedYet(true);
    }
  }, [props.data.row.original.assignmentList,
  props.data.row.original.assignmentList[assignUpdateDetails.assignIndex]?.providerName,
    updateLockUnlockRows
  ]);




  const onChange = useCallback((e, item) => {
    setAssignedProviderId(item.key);
    let reportingProvider = {
      studyId: props.data.row.original.id,
      clientId: props.data.row.original.assignmentList[0].clientId,
      firmId: props.data.row.original.assignmentList[0].firmId,
      providerId: item.key,
      assignedProviderId: props.data.row.original.assignmentList[0].providerId,
    };
    setReportingProviderDto(reportingProvider);
    props.batchAssign(reportingProvider, true);
    setSelected(true);
  });

  const unselectRadiologist = (studyId) => {

    let reportingProvider = {
      studyId: studyId,
    };
    console.log("--- Removed Value ----", reportingProvider)
    props.batchAssign(reportingProvider, false);
    //setSelected(false);
  };

  const handleSelection = () => {
    console.log("---------handle selection method--------", showConfirmation);
    const assignmentList = props.data.row.original.assignmentList;
    //let providerId = props.data.row.original.assignmentList[0].providerId;
    console.log(assignedProviderId, props.data.row.original.assignmentList[0].providerId);
    if (assignedProviderId != undefined && assignedProviderId != 0) {
      if (providerId === "" || providerId !== assignedProviderId
        || props.data.row.original.assignmentList[0].providerId != assignedProviderId
        || (roles[0] === USERTYPES.ADMIN && assignmentList[assignmentList.length - 1].provider != assignedProviderId)) {
        validateAndAssignProvider();
      } else {
        showToastv2(TOAST_TYPE.INFO, t("placeholder.select-other-provider"));
      }
    } else {
      showToastv2(TOAST_TYPE.INFO, t("placeholder.select-provider"));
    }
  };
  const onConfirmButtonClick = () => {
    setResetRowSelection(true);
    console.log("confirm button clicked------");
    callAssignProviderService();
  };

  const proceedWithAssignmentFlow = () => {
    if (!showConfirmation) {
      callAssignProviderService();
    } else {
      setShowConfirmationDialog(true);
    }
  };

  const validateAndAssignProvider = async () => {
    if (!reportingProviderDto?.studyId || !reportingProviderDto?.providerId) {
      showToastv2(TOAST_TYPE.INFO, t("placeholder.select-provider"));
      return;
    }

    const validationPayload = {
      batchProviders: [{
        studyId: reportingProviderDto.studyId,
        clientId: reportingProviderDto.clientId,
        firmId: reportingProviderDto.firmId,
        providerId: reportingProviderDto.providerId,
        assignName: reportingProviderDto.assignName,
      }],
    };

    const validateResponse = await validateAssignment(validationPayload);
    const isValidateSuccess = validateResponse?.status === 200 && validateResponse?.data != null;

    if (isValidateSuccess) {
      const conflicts = validateResponse?.data?.data?.conflicts || validateResponse?.data?.conflicts || [];
      if (conflicts.length > 0) {
        const row = props.data.row.original;
        const newConflicts = conflicts.map((conflict) => ({
          ...conflict,
          patientName: row?.patientName,
          accessionNumber: row?.accessionNumber,
        }));
        setAssignmentConflicts(newConflicts);
        setShowAssignmentConflictModal(true);
        return;
      }
    }

    proceedWithAssignmentFlow();
  };

  const handleUpdateRowForAssign = (data) => {

    var currentDate = Moment().format('DD-MMM-YY HH:mm');
    let newIndex = -1;
    let newData = dataQueryState?.data?.rows.filter(
      (row, index) => {
        if (row.id == props.data.row.original.id) {
          newIndex = index;
          return true;
        }
        return false;
      }
    );
    setDataQueryState(() => {
      const newValue = {
        ...dataQueryState
      };
      newValue.data.rows[newIndex].assignmentList[assignUpdateDetails.assignIndex].providerName = assignUpdateDetails.assignName;
      newValue.data.rows[newIndex].assignmentList[assignUpdateDetails.assignIndex].providerId = assignUpdateDetails.assignId;
      if (!assignUpdateDetails.assignName?.includes(" : ")) {
        newValue.data.rows[newIndex].assignmentList[assignUpdateDetails.assignIndex].specialist = "";
      }
      // newValue.data.rows[newIndex].assignmentList[assignUpdateDetails.assignIndex].assignmentDateDisplay = currentDate;
      return newValue;
    });

  }

  const handleAutoUpdateForSelectAssignment = (assignmentList) => {
    let newIndex = -1;
    let newData = dataQueryState?.data?.rows.filter(
      (row, index) => {
        if (row.id == props.data.row.original.id) {
          newIndex = index;
          return row;
        }
        return false;
      }
    );
    let oldAssignmentList = dataQueryState?.data?.rows[newIndex].assignmentList;
    console.log("--- Old Assignment List ---", oldAssignmentList);
    if (assignmentList.length > 0 && assignmentList[0].providerId.startsWith("F")) {
      if (assignmentList[1] != undefined && assignmentList[1] != null) {
        oldAssignmentList.push(assignmentList[1]);
        setDataQueryState(() => {
          const newValue = {
            ...dataQueryState
          };
          newValue.data.rows[newIndex].assignmentList = oldAssignmentList;
          return newValue;
        });
      }
    }

  }

  const callAssignProviderService = async () => {
    const body = {
      reportingProvider: reportingProviderDto,
      baseURL: baseURL,
    };
    console.log(body);
    //setLoaderRunning(true);
    //ref.current.continuousStart();
    setIsLoadingAssignment(true);
    const response =
      roles[0] === USERTYPES.ADMIN
        ? await assignProviderByAdmin(body)
        : await assignProvider(body);
    console.log("--- Data assign ---", response);

    if (response.status === 200 && response.data.result === "SUCCESS") {
      setProviderId(assignedProviderId);
      if (roles[0] === USERTYPES.ADMIN) {
        try {
          handleAutoUpdateForSelectAssignment(response?.data?.data?.assignmentList);
        } catch (e) {
          console.log("--- Error in creating new assignment row ----");
        }

      }
      handleUpdateRowForAssign(reportingProviderDto)
      //ref.current.complete();
      setIsLoadingAssignment(false);
      showToastv2(
        TOAST_TYPE.SUCCESS,
        roles[0] === USERTYPES.ADMIN
          ? t("study-list.messages.assign-success")
          : t("study-list.messages.assign-success-to", { name: response.data.data })
      );
      props.batchAssign(reportingProviderDto, false);
    } else {
      //ref.current.complete();
      setIsLoadingAssignment(false);
      showToastv2(
        TOAST_TYPE.ERROR,
        roles[0] === response?.data?.message != null ? response.data.message : (USERTYPES.ADMIN
          ? t("study-list.messages.assign-error")
          : t("study-list.messages.assign-error-to", { name: response.data.data }))
      );
    }
  };





  const handleRevertCloseStudyApiFunc = async () => {
    setShowRevertConfirmModal(false);
    setShowConfirmModal(false);

    const response = await RevertCloseStudyApi(props.data.row.original.id, assignmentId);
    if (response.data.message === "database_error") {
      // setShowRevertStudyResponseMsg(t("confirm-message.revert-closeStudy-database-error-message"));
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("confirm-message.revert-closeStudy-database-error-message");
        return newItem;
      });
    } else {
      // setShowRevertStudyResponseMsg(response.data.message);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = response.data.message;
        return newItem;
      });
      if (props.tabId == TAB_NAME.CLOSED) {
        setTimeout(() => {
          setRefreshRequired(() => {
            const newItem = { ...refreshRequired };
            newItem[TAB_NAME.UNREPORTED].alreadyLoaded = false;
            return newItem;
          });
        }, 10);

        let newData = dataQueryState?.data?.rows.filter(
          (row) => row.id !== props.data.row.original.id
        );
        setDataQueryState(() => {
          const newValue = {
            ...dataQueryState,
          };
          newValue.data.rows = newData;
          return newValue;
        });
      }


    }
    setShowRevertReponseModal(true);
    setShowConfirmModal(true);
  }

  const handleRevertCloseStudyModal = (item) => {
    if (showRevertConfirmModal) {
      setShowRevertConfirmModal(false);
      setShowConfirmModal(false);
    } else {
      setAssignmentId(item?.id);
      setShowRevertConfirmModal(true);
      setShowConfirmModal(true);
    }
  }

  const handleSendReport = () => {
    // send report via attachment or/and send report via link
    setShowSendReportModalBool(true);
  }

  useEffect(() => {
    //console.log("--- Running ShowReportBool ---",showSendReportModalBool);
    if (!showSendReportModalBool) {
      setShowSendReportModal(() => {
        const newItem = { ...showSendReportModal };
        newItem.show = false;
        newItem.clientId = false;
        newItem.firmId = false;
        return newItem;
      })
    }
  }, [showSendReportModalBool])

  const options = ["Option 1", "Option 2", "Option 3", "Option 4"];

  const mainStackStyles = {
    // lineHeight: "20px",
    // height: "121px",
    // width: "210px",
    justifyContent: "center",
    marginTop: CUSTOM_STYLES.STUDYLIST_TD_TOP_MARGIN,
    // transform: "translateY(-39%)"
  };

  const radiologistStackStyles = {
    justifyContent: "center",
    marginTop: CUSTOM_STYLES.STUDYLIST_TD_TOP_MARGIN,
  }

  const getSelectedValue = (value, key, index) => {
    setAssignedProviderId(key);
    let reportingProvider = {
      studyId: props.data.row.original.id,
      clientId: props.data.row.original.assignmentList[index].clientId,
      firmId: props.data.row.original.assignmentList[index].firmId,
      providerId: key,
      assignedProviderId:
        props.data.row.original.assignmentList[index].providerId,
      assignName: value
    };
    setAssignUpdateDetails({
      assignName: value,
      assignId: key,
      assignIndex: index
    })
    setReportingProviderDto(reportingProvider);
    props.batchAssign(reportingProvider, true);
    setSelected(true);
  };

  return (
    <>
      {isLoadingAssignment ?
        <div
          style={{
            display: "flex",
            //flexDirection: "row",
            alignItems: "center",
            flexDirection: 'center',
            marginTop: "30px"
          }}
        >
          <Spinner size={SpinnerSize.large} styles={smallSpinnerStyle} />
        </div>
        : <Stack style={roles[0] === USERTYPES.RADIOLOGIST ? radiologistStackStyles : mainStackStyles} data-tut={"tour-provider-details"}>
          {<div
            style={{
              //width: "250px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              //transform: "translateY(8%)"
            }}
          >

            {(roles[0] === USERTYPES.ADMIN ||
              roles[0] === USERTYPES.FIRMADMIN ||
              roles[0] === USERTYPES.SUPERVISOR) ? (
              <>
                {showRevertConfirmModal && showConfirmModal &&
                  <ConfirmModal handleConfirm={handleRevertCloseStudyApiFunc} handleNotConfirm={handleRevertCloseStudyModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message="Do you really want to revert the closed study back to open state?"
                    title={t("confirm-message.revert-closed-study")} confirmButtonText={t("confirm-message.yes")} />
                }
                {showAssignmentConflictModal && (
                  <AssignmentConflictModal
                    showModal={showAssignmentConflictModal}
                    handleConfirm={() => {
                      setShowAssignmentConflictModal(false);
                      callAssignProviderService();
                    }}
                    handleNotConfirm={() => {
                      setShowAssignmentConflictModal(false);
                    }}
                    title={t("confirm-message.alert")}
                    confirmButtonText={t("confirm-message.yes")}
                    cancelButtonText={"Cancel"}
                    conflicts={assignmentConflicts}
                  />
                )}
                {(showSendReportModalBool && showSendReportModal.show) &&
                  <SendReportEmail assignmentChain={true} showSendReportModal_={showSendReportModalBool} setShowSendReportModal_={setShowSendReportModalBool} studyId={props.data.row.original.id} assignmentList={props.data.row.original.assignmentList} firmId={showSendReportModal.firmId} clientId={showSendReportModal.clientId} />
                }
                {roles[0] === USERTYPES.ADMIN && (
                  <>
                    <SuperAdminRadiologist
                      notAssignedYet={notAssignedYet}
                      data={props.data}
                      getSelectedValue={getSelectedValue}
                      unselectRadiologist={unselectRadiologist}
                      handleSelection={handleSelection}
                      handleRevertCloseStudyModal={handleRevertCloseStudyModal}
                      tabId={props.tabId}
                      handleSendReport={handleSendReport}
                    />
                  </>
                )}
                {(roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.FIRMADMIN) && (
                  <FirmRadiologist
                    getSelectedValue={getSelectedValue}
                    data={props.data}
                    unselectRadiologist={unselectRadiologist}
                    handleSelection={handleSelection}
                    handleRadiologistTimeSpent={handleRadiologistTimeSpent}
                    tabId={props.tabId}
                  />
                )}
              </>
            ) : (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Stack horizontal style={firstRowNameStack}>
                  <span className="study-list-assignment-details-text">
                    <RowBadgeStatic
                      name={
                        props.data.row.original.assignmentList[0].providerId &&
                          props.data.row.original.assignmentList[0].providerId.startsWith("R")
                          ? "R"
                          : "P"
                      }
                      tooltipText={
                        props.data.row.original.assignmentList[0].providerId &&
                          props.data.row.original.assignmentList[0].providerId.startsWith("R")
                          ? t("radiologist.radiologist")
                          : t("navbar.provider")
                      }
                    />
                  </span>
                  {reviewerId != null &&
                    reviewerId == userId &&
                    (props.tabId == TAB_NAME.REVIEWASSIGNED ||
                      props.tabId == TAB_NAME.REVIEWCOMPLETE) ? (
                    <CustomToolTipHost
                      content={`${props.data.row.original.peerReviewAssignment?.reviewer.firstName} ${props.data.row.original.peerReviewAssignment?.reviewer.lastName}`}
                      id={
                        "tooltip_" +
                        props.data.row.original.assignmentList[0].providerName
                      }
                    >
                      <span
                        className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                        style={{ width: "120px", display: "block" }}
                      >
                        &nbsp;&nbsp;
                        {props.data.row.original.peerReviewAssignment?.reviewer.firstName +
                          " " +
                          props.data.row.original.peerReviewAssignment?.reviewer.lastName}
                      </span>
                    </CustomToolTipHost>
                  ) : props.data.row.original.assignmentList[0].providerId != null ? (
                    <CustomToolTipHost
                      content={`${props.data.row.original.assignmentList[0].providerId &&
                          props.data.row.original.assignmentList[0].providerId.startsWith("R")
                          ? t("radiologist.radiologist")
                          : t("navbar.provider")
                        }: ${getRadiologistDisplayName({
                          name: props.data.row.original.assignmentList[0].providerName,
                          specialist:
                            props.data.row.original.assignmentList[0].specialist,
                        })}`}
                      id={
                        "tooltip_" +
                        props.data.row.original.assignmentList[0].providerName
                      }
                    >
                      <span
                        className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                        style={{ width: "120px", display: "block" }}
                      >
                        &nbsp;&nbsp;
                        {getRadiologistDisplayName({
                          name: props.data.row.original.assignmentList[0].providerName,
                          specialist:
                            props.data.row.original.assignmentList[0].specialist,
                        })}
                      </span>
                    </CustomToolTipHost>
                  ) : (
                    <span className="study-list-assignment-details-text study-list-row-badge">
                      &nbsp;&nbsp;{t("label.not-assigned")}
                    </span>
                  )}
                </Stack>

                {(roles[0] != USERTYPES.FIRMTECHNICIAN &&
                  roles[0] != USERTYPES.FIRMDOCTOR &&
                  roles[0] != USERTYPES.TYPIST) && (
                    <Stack horizontal style={radiologistNameStack}>
                      <span className="study-list-assignment-details-text">
                        <RowBadgeStatic
                          name={
                            props.data.row.original.assignmentList[0].firmName?.toLowerCase().startsWith("__p_")
                              ? "Pr"
                              : "F"
                          }
                          tooltipText={
                            props.data.row.original.assignmentList[0].firmName?.toLowerCase().startsWith("__p_")
                              ? "Project"
                              : t("navbar.firm")
                          }
                        />
                      </span>
                      {props.data.row.original.assignmentList[0].firmName != null ? (
                        <CustomToolTipHost
                          content={`${t("navbar.firm")}: ${props.data.row.original.assignmentList[0].firmName.replace(/^__p_/i, "")
                            }`}
                          id={
                            "tooltip_" +
                            props.data.row.original.assignmentList[0].firmName.replace(/^__p_/i, "")
                          }
                        >
                          <span
                            className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                            style={{ width: "150px" }}
                          >
                            &nbsp;&nbsp;
                            {props.data.row.original.assignmentList[0].firmName.replace(/^__p_/i, "")}
                          </span>
                        </CustomToolTipHost>
                      ) : (
                        <span className="study-list-assignment-details-text study-list-row-badge">
                          &nbsp;&nbsp;{t("label.not-assigned")}
                        </span>
                      )}
                    </Stack>
                  )}

                {((showClientName) &&
                  roles[0] != USERTYPES.FIRMTECHNICIAN &&
                  roles[0] != USERTYPES.FIRMDOCTOR &&
                  roles[0] != USERTYPES.TYPIST) && (
                    <Stack horizontal style={radiologistNameStack}>
                      <span className="study-list-assignment-details-text">
                        <RowBadgeStatic
                          name={
                            props.data.row.original.assignmentList[0].clientName?.toLowerCase().startsWith("__p_")
                              ? "Pr"
                              : "C"
                          }
                          tooltipText={
                            props.data.row.original.assignmentList[0].clientName?.toLowerCase().startsWith("__p_")
                              ? "Project"
                              : t("navbar.client")
                          }
                        />
                      </span>

                      <CustomToolTipHost
                        content={`${t("navbar.client")}: ${props.data.row.original.assignmentList[0].clientName?.replace(/^__p_/i, "")
                          }`}
                        id={"tooltip_" + props.data.row.original.assignmentList[0].clientId}
                      >
                        {props.data.row.original.assignmentList[0].clientId != 0 &&
                          props.data.row.original.assignmentList[0].clientId != null ? (
                          <span
                            className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                            style={{ width: "120px" }}
                          >
                            &nbsp;&nbsp;
                            {props.data.row.original.assignmentList[0].clientName?.replace(/^__p_/i, "")}
                          </span>
                        ) : (
                          <span
                            className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                            style={{ width: "120px" }}
                          >
                            &nbsp;&nbsp; -
                          </span>
                        )}
                      </CustomToolTipHost>
                    </Stack>
                  )}
              </div>

            )}
          </div>}

          <DialogBox
            setShowDialogBox={setShowConfirmationDialog}
            showDialogBox={showConfirmationDialog}
            styles={confirmDialogBoxStyles}
            title="Confirmation"
            message={t("confirm-message.assign-study-confirmation")}
            confirmButtonText={t("button.yes")}
            onConfirmButtonClick={onConfirmButtonClick}
          />
        </Stack>}
    </>
  );
};

export default RadiologistDetails;

export const RowBadgeStatic = (props) => {
  const { getRowBadgeBackgroundOrBorderColor } = useContext(themeContext);
  const badgeStyle = {
    backgroundColor:
      props.colorObj != undefined ? props.colorObj.background : "unset",
  };

  const customAssignmentTooltip = {
    root: "study-list-assigment-badge"
  }

  return (
    <>
      <div className="studylist-row-static-text"
        style={props.style != undefined ? props.style : props.colorObj ? badgeStyle : {
          background: getRowBadgeBackgroundOrBorderColor(props.name, "background"),
          border: getRowBadgeBackgroundOrBorderColor(props.name, "border"),
          color: getRowBadgeBackgroundOrBorderColor(props.name, "color"),
        }

        }

      >
        <CustomToolTipHost
          styles={customAssignmentTooltip}
          content={
            props.tooltipText != undefined ? props.tooltipText : props.name
          }
          id={"tooltip_" + props.name}
        >
          <span
            className="study-list-row-badge"
            style={{ width: props.width != undefined ? props.width : "unset", cursor: props.clickable ? "pointer" : "text" }}
          >
            {props.name}
          </span>
        </CustomToolTipHost>
      </div>
    </>
  );
};
